/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { createColumnHelper } from "@tanstack/react-table";
import dayjs from "dayjs";
import { FlexContainer } from "@nordcloud/gnui";
import { CloudResourceReportResultFragment } from "~/generated/graphql";
import {
  LargeColumn,
  MediumColumn,
  SmallIconColumn,
} from "~/components/Tables/styles";
import { dateFormat, TABLE_LABELS } from "~/constants";
import { Actions } from "./Actions";
import { ResourceReportStatus } from "./ResourceReportStatus";

const columnHelper = createColumnHelper<CloudResourceReportResultFragment>();

export function columns() {
  return [
    columnHelper.accessor(() => null, {
      id: "status",
      header: () => null,
      cell: ({ row }) => {
        return <ResourceReportStatus status={row.original.status} />;
      },
      meta: SmallIconColumn,
    }),
    columnHelper.accessor(() => null, {
      id: "name",
      header: () => "Report Name",
      cell: ({ row }) => {
        return <FlexContainer>{row.original.name}</FlexContainer>;
      },
      meta: LargeColumn,
    }),
    columnHelper.accessor(() => null, {
      id: "dateGenerated",
      header: () => "Date Generated",
      cell: ({ row }) => {
        return (
          <FlexContainer>
            {row.original.dateGenerated
              ? dayjs(row.original.dateGenerated).format(
                  dateFormat.dayMonthYearHourMinute
                )
              : ""}
          </FlexContainer>
        );
      },
      meta: MediumColumn,
    }),
    columnHelper.accessor(() => null, {
      id: "createdBy",
      header: () => TABLE_LABELS.createdBy,
      cell: ({ row }) => {
        return (
          <FlexContainer>{row.original.changeDetails.createdBy}</FlexContainer>
        );
      },
      meta: MediumColumn,
    }),
    columnHelper.accessor(() => null, {
      id: "options",
      header: () => null,
      cell: ({ row }) => {
        const reportDetails = {
          id: row.original?.id,
          status: row.original.status,
          url: row.original?.url,
          name: row.original.name,
        };
        return <Actions {...reportDetails} />;
      },
      meta: SmallIconColumn,
    }),
  ] as never;
}
